import styled from 'styled-components';
import { StoreButtons } from './StoreButtons';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Body, Caption } from 'app/components/Typography';
import { bookitColors } from 'styles/colors/bookitColors';
import { useTheme } from '@material-ui/core';
import React from 'react';

export interface GetMobileAppProps {}
export const AppButtonsPanel = styled('div')(({ theme }) => ({
  '&.appContainer': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '14px',
  },
}));
export function GetMobileApp(props: GetMobileAppProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const loginFooterApps = React.useMemo(() => {
    return t(translations.LoginFooterApps);
  }, [t]);
  return (
    <AppButtonsPanel className={'appContainer'} theme={theme}>
      <Body bold size="small" style={{ color: bookitColors.base.white }}>
        {t(translations.AppAccountButtonsTitle)}
      </Body>
      <StoreButtons />
      {!!loginFooterApps && loginFooterApps !== '' && (
        <Caption bold style={{ color: bookitColors.base.white }}>
          {t(translations.LoginFooterApps)}
        </Caption>
      )}
    </AppButtonsPanel>
    // <div className={classes.downloadApp}>
    //   <div className={classes.downloadAppTitle}>
    //     <Body bold size="small" style={{ color: bookitColors.base.white }}>
    //       {'Get the mobile App'}
    //     </Body>
    //   </div>
    //   <StoreButtons />
    //   <div className={classes.downloadAppFooter}>
    //     <Caption bold style={{ color: bookitColors.base.white }}>
    //       {t(translations.LoginFooterApps)}
    //     </Caption>
    //   </div>
    // </div>
  );
}
